(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inoxium-foundry"] && !Shopify.designMode) return;
  try {
    (function () {
  var rail = document.querySelector('.inox-rail');
  if (rail && !CSS.supports('animation-timeline', 'scroll()')) {
    var update = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var progress = max > 0 ? window.scrollY / max : 0;
      rail.style.transform = 'scaleY(' + Math.max(0.04, Math.min(1, progress)) + ')';
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  var fields = {
    Pink: '#e7b3b8',
    Navy: '#1a3344',
    Green: '#6f8a63',
    White: '#e8eef2',
    Yellow: '#e2c56a',
    Red: '#c45c4a',
    Black: '#1a1c1e',
    Gold: '#c9a24a',
    Purple: '#7a5b86',
    Blue: '#3d6a8a'
  };

  var selectedColor = function () {
    var inputs = document.querySelectorAll('.variant-picker input:checked, .variant-option input:checked, variant-picker input:checked');
    for (var i = 0; i < inputs.length; i++) {
      if (fields[inputs[i].value]) return fields[inputs[i].value];
    }
    return null;
  };

  var dye = function () {
    var color = selectedColor();
    if (!color) return;
    document.documentElement.style.setProperty('--inox-field-raw', color);
  };

  var isVariantEvent = function (event) {
    return event.target && event.target.closest &&
      event.target.closest('.variant-picker, .variant-option, variant-picker');
  };

  /* Mask the window in which Horizon paints slide 1, using a fill-mode:both
     CSS animation. The gallery has no inline opacity at any point, so the
     worst case is an un-animated but fully visible gallery. Never blank. */
  var swapTimer = null;

  var clearSwap = function () {
    var el = document.querySelector('.inox-swapping');
    while (el) {
      el.classList.remove('inox-swapping');
      el = document.querySelector('.inox-swapping');
    }
  };

  var crossfade = function () {
    var gallery = document.querySelector('media-gallery, .media-gallery');
    if (!gallery) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    gallery.classList.remove('inox-swapping');
    void gallery.offsetWidth;
    gallery.classList.add('inox-swapping');
    /* Horizon swaps the gallery subtree mid-animation, so animationend can
       never be relied on to land. This timeout is what actually guarantees
       the media becomes visible again. */
    window.clearTimeout(swapTimer);
    swapTimer = window.setTimeout(clearSwap, 900);
  };

  /* The animating node is a child; the class lives on the gallery. Walk up. */
  document.addEventListener('animationend', function (event) {
    if (event.animationName !== 'inox-media-swap') return;
    var gal = event.target.closest && event.target.closest('media-gallery, .media-gallery');
    if (gal) gal.classList.remove('inox-swapping');
  });

  var onVariantChange = function (event) {
    if (!isVariantEvent(event)) return;
    crossfade();
    dye();
    window.setTimeout(dye, 90);
    window.setTimeout(dye, 240);
  };

  document.addEventListener('change', onVariantChange);
  document.addEventListener('click', function (event) {
    if (!isVariantEvent(event)) return;
    window.setTimeout(dye, 20);
    window.setTimeout(dye, 160);
  });

  dye();
  window.setTimeout(dye, 300);
})();
  } catch(e) { console.error(e); }
})();

})();
